import { Fragment } from 'react';

import classes from './AddProperty.module.css';

import Header from '../UIHeader/Header';

const ModalLayout = (props) => {
  return (
    <Fragment>
      <div className={classes.backdrop} onClick={props.hideModal} role="presentation">
        <Header />
      </div>
      <div className={classes.modal}>{props.children}</div>
    </Fragment>
  );
};

export default ModalLayout;
